import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import YandexReviewsWidget from '../components/YandexReviewsWidget';
import { 
  IconPhone, 
  IconPin, 
  IconShieldCheck, 
  IconClock, 
  IconWrench, 
  IconCarService, 
  IconWallet, 
  IconLayers 
} from '../components/Icons';

const HomePage = () => {
    useEffect(() => {
        document.title = "Автостекло-Сервис Бийск — ремонт и замена автостекол";
    }, []);

    return (
        <div className="home-page">
            <section className="hero-section">
                <h1>Продажа, ремонт и установка автостекол в Бийске</h1>
                <p>Профессиональный сервис с гарантией качества и широким ассортиментом стекол в наличии.</p>
                <div style={{ marginTop: '25px' }}>
                    <a href="tel:+79609474777" className="btn-primary cta-button">
                        <IconPhone size={19} color="#000" />
                        <span>Позвонить: +7 (960) 947-47-77</span>
                    </a>
                </div>
            </section>

            <section id="services" className="services-section">
                <h2>Наши услуги</h2>
                <div className="services-grid">
                    <div className="service-card">
                        <h3>Продажа автостекол</h3>
                        <p>Широкий ассортимент лобовых, задних и боковых стекол для большинства марок автомобилей. Работаем с надежными производителями.</p>
                    </div>
                    <div className="service-card">
                        <h3>Профессиональная установка</h3>
                        <p>Быстрая и качественная замена стекла с использованием качественного материала и соблюдением технологий установки. Гарантия на герметичность.</p>
                    </div>
                    <div className="service-card">
                        <h3>Ремонт сколов и трещин</h3>
                        <p>Останавливаем трещины и восстанавливаем прозрачность поврежденного участка полимером. Предотвращает необходимость полной замены стекла.</p>
                    </div>
                </div>
            </section>

            <section id="why-us" className="why-us-section">
                <h2>Почему выбирают нас</h2>
                <div className="why-us-grid">
                    
                    <div className="advantage-card">
                        <div className="advantage-icon-box">
                            <IconShieldCheck size={26} color="#a80000" />
                        </div>
                        <h3>Гарантия качества</h3>
                        <p>Используем только сертифицированные стекла и герметики. Предоставляем официальную гарантию на выполненную установку.</p>
                    </div>

                    <div className="advantage-card">
                        <div className="advantage-icon-box">
                            <IconClock size={26} color="#a80000" />
                        </div>
                        <h3>Экономия времени</h3>
                        <p>Ходовые модели стекол держим на складе в Бийске, поэтому замену часто производим прямо в день обращения.</p>
                    </div>

                    <div className="advantage-card">
                        <div className="advantage-icon-box">
                            <IconWrench size={26} color="#a80000" />
                        </div>
                        <h3>Опытные мастера</h3>
                        <p>Специалисты со стажем работы более 15 лет знают все тонкости кузовов европейских, японских, корейских и отечественных авто.</p>
                    </div>

                    <div className="advantage-card">
                        <div className="advantage-icon-box">
                            <IconCarService size={26} color="#a80000" />
                        </div>
                        <h3>Выезд мастера</h3>
                        <p>Возможен оперативный выезд специалистов по городу и за его пределы для установки и ремонта стекла.</p>
                    </div>

                    <div className="advantage-card">
                        <div className="advantage-icon-box">
                            <IconWallet size={26} color="#a80000" />
                        </div>
                        <h3>Подбор под любой бюджет</h3>
                        <p>В наличии как стекла оригинального качества, так и надежные фабричные аналоги по доступной цене.</p>
                    </div>

                    <div className="advantage-card">
                        <div className="advantage-icon-box">
                            <IconLayers size={26} color="#a80000" />
                        </div>
                        <h3>Современные технологии</h3>
                        <p>Используем профессиональный инструмент, праймеры и клеи европейского качества для максимальной надежности.</p>
                    </div>

                </div>
            </section>

            <section id="reviews" className="reviews-section">
                <h2>Отзывы наших клиентов</h2>
                <YandexReviewsWidget />
            </section>

            <section className="cta-section">
                <h2>Остались вопросы или хотите записаться?</h2>
                <p>Позвоните нам для консультации или приезжайте в сервис.</p>
                <div className="cta-buttons">
                    <a href="tel:+79609474777" className="btn-primary cta-button">
                        <IconPhone size={19} color="#000" />
                        <span>Позвонить: +7 (960) 947-47-77</span>
                    </a>
                    <Link to="/contacts" className="btn-secondary cta-button">
                        <IconPin size={19} color="#333" />
                        <span>Контактная информация</span>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default HomePage;